import React from 'react'
import './Globeimg.css'
import { images } from '../../../assets'

function Globeimg() {
  return (
    <div className='globeimg'>
        <img src={images.globeImg} alt='globe-img' />
    </div>
  )
}

export default Globeimg
